/* FIRAL Claude Design Preview — interactivity (reveal + header-scroll) */
(function () {
  'use strict';

  // Reveal on intersection (for .reveal and .reveal-stagger)
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add('is-visible');
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
      )
    : null;

  function observeReveals() {
    document.querySelectorAll('.reveal, .reveal-stagger').forEach((el) => {
      if (!el.classList.contains('is-visible') && io) io.observe(el);
      else el.classList.add('is-visible');
    });
  }

  // Header scrolled state
  const hdr = document.querySelector('.header-wrapper, .section-header, .hdr');
  let lastY = 0;
  function onScroll() {
    const y = window.scrollY || window.pageYOffset;
    if (hdr) {
      if (y > 24) hdr.classList.add('is-scrolled');
      else hdr.classList.remove('is-scrolled');
    }
    lastY = y;
  }

  // Marquee pause on hover (accessibility)
  document.querySelectorAll('.marquee__track').forEach((track) => {
    track.addEventListener('mouseenter', () => (track.style.animationPlayState = 'paused'));
    track.addEventListener('mouseleave', () => (track.style.animationPlayState = 'running'));
  });

  // Hero parallax (portado do preview)
  const heroMedia = document.querySelector('.hero__media');
  let parallaxRaf = 0;
  function parallax() {
    if (!heroMedia) return;
    const y = window.scrollY;
    if (y < window.innerHeight) {
      heroMedia.style.transform = `translateY(${y * 0.3}px) scale(${1 + y * 0.0003})`;
    }
  }
  function onScrollParallax() {
    if (parallaxRaf) return;
    parallaxRaf = requestAnimationFrame(() => {
      parallax();
      parallaxRaf = 0;
    });
  }
  if (heroMedia) {
    window.addEventListener('scroll', onScrollParallax, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observeReveals();
      onScroll();
    });
  } else {
    observeReveals();
    onScroll();
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // Expose rebind for dynamically added sections (theme editor)
  document.addEventListener('shopify:section:load', () => observeReveals());
})();
